export enum AssetType {
    Dataset = 'Dataset',
    Model = 'Model',
    Result = 'Result',
}
